import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from "react";
import PropTypes from "prop-types";
import Toast from "src/components/UtilityComponents/notifications/toast/Toast";
import { CToaster } from "@coreui/react";

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((content, options = {}) => {
    const id = Math.random().toString(36);
    const type = options.type || "success";
    setToasts((currentToasts) => [
      ...currentToasts,
      { id, content, type, ...options },
    ]);
    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((currentToasts) =>
      currentToasts.filter((toast) => toast.id !== id),
    );
  }, []);

  const contextValue = useMemo(
    () => ({ addToast, removeToast }),
    [addToast, removeToast],
  );

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <CToaster className="toast-container">
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            type={toast.type}
            title={toast.title}
            content={toast.content}
            delay={toast.delay || 10000}
            copy={toast.copy || false}
            autohide={toast.autohide}
          />
        ))}
      </CToaster>
    </ToastContext.Provider>
  );
};

ToastProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
